<script
  lang="ts"
  generics="TContent extends ColumnDefTemplate<any> | string | undefined, TContext"
>
  import type { ColumnDefTemplate } from "@tanstack/table-core"
  import {
    RenderComponentConfig,
    RenderSnippetConfig,
  } from "./render-component"

  type Props = {
    content: TContent
    context: TContext
  }

  let { content, context }: Props = $props()
</script>

{#if typeof content === "string"}
  {content}
{:else if content instanceof Function}
  {@const result = content(context as any)}
  {#if result instanceof RenderComponentConfig}
    {@const { component: Component, props } = result}
    <Component {...props as Record<string, unknown>} />
  {:else if result instanceof RenderSnippetConfig}
    {@const { snippet, params } = result}
    {@render snippet(params)}
  {:else}
    {result}
  {/if}
{/if}
